import React from 'react';
import { useField } from 'formik';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
const DateTimePicker = ({
  name,
  label,
  minDate,
  maxDate,
  onChange,
  disableFuture,
  disablePast,
  ...otherProps
}) => {
  const [field, mata] = useField(name);
  const configTextField = {
    ...field,
    ...otherProps,
    fullWidth: true,
    variant: 'outlined',
    onChange,
  };

  if (mata && mata.touched && mata.error) {
    configTextField.error = true;
    configTextField.helperText = mata.error;
  }

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          disablePast={disablePast}
          disableFuture={disableFuture}
          name={name}
          label={label}
          minDate={minDate}
          maxDate={maxDate}
          format="DD/MM/YYYY"
          inputFormat="DD/MM/YYYY"
          onChange={onChange}
          slotProps={{
            textField: {
              name: name,
              label: label,
              ...configTextField,
              variant: 'outlined',
              onChange: onChange,
            },
          }}
        />
      </LocalizationProvider>
    </>
  );
};

export default DateTimePicker;
